import * as React from "react";
import { SessionTypes } from "../../misc/api/ApiSessionTypes";
import TechnicianSessionComments from "../Spirometry/Testing/TechnicianSessionComments/TechnicianSessionComments";
import TechnicianTestComments from "../Spirometry/Testing/TechnicianTestComments/TechnicianTestComments";
import { FixedCommentsSelectors } from "./FixedCommentsSelectors";
import { PFTResults, SpirometryResults } from "./PFTAPITypes";
import ResultsGroupHeading from "./ResultsGroupHeading";
import { SelectedSessionCommentsCount, SelectedTestCommentsCount } from "./Selectors/FixedCommentSelectors";
import { FixedCommentsState, ToggleSessionFixedCommentsVisibilityAction, ToggleTestFixedCommentsVisibilityAction } from "./UseFixedComments";

export interface ResultsCommentsTableProps {
    siteAnalysisSetId: string;
    resultData: PFTResults;
    fixedCommentsState: FixedCommentsState;
    fixedCommentsDispatch;
    technicianSessionCommentsAvailable: boolean;
    technicianTestCommentsAvailable: boolean;
    addCommentsSuffix: boolean;
    sessionType: SessionTypes;
}

export const ResultsCommentsTable = ({
    siteAnalysisSetId,
    resultData,
    fixedCommentsState,
    fixedCommentsDispatch,
    technicianSessionCommentsAvailable,
    technicianTestCommentsAvailable,
    addCommentsSuffix,
    sessionType
}: ResultsCommentsTableProps) => {
    return (
        <>
            <ResultsGroupHeading resultsCount={resultData.TestResults.length} title="Comments" />

            <FixedCommentsSelectors
                addCommentsSuffix={addCommentsSuffix}
                testResults={resultData.TestResults}
                selectedTestCommentsCount={SelectedTestCommentsCount(fixedCommentsState.testFixedComments)}
                selectedSessionCommentsCount={SelectedSessionCommentsCount(
                    fixedCommentsState.sessionFixedComments
                )}
                onTestFixedCommentClick={testId =>
                    fixedCommentsDispatch(ToggleTestFixedCommentsVisibilityAction.create(testId))
                }
                onSessionFixedCommentClick={() =>
                    fixedCommentsDispatch(ToggleSessionFixedCommentsVisibilityAction.create())
                }
            />

            {
                technicianSessionCommentsAvailable || technicianTestCommentsAvailable
                    ? (
                        <tr>
                            <td>{addCommentsSuffix ? "Technician Comments" : "Technician"}</td>
                            {
                                resultData.TestResults.map(tr => {
                                    return (
                                        <td key={`TechnicianTC${tr.TestId}`}>
                                            {
                                                technicianTestCommentsAvailable
                                                    ? <TechnicianTestComments
                                                        TestId={tr.TestId}
                                                        TestNumber={tr.TestNumber}
                                                        AnalysisSetId={siteAnalysisSetId}
                                                        IsReadOnly={true}
                                                        SessionType={sessionType}
                                                    />
                                                    : "-"
                                            }
                                        </td>
                                    );
                                })}
                            <td>
                                {technicianSessionCommentsAvailable ? <TechnicianSessionComments AnalysisSetId={siteAnalysisSetId} IsReadOnly={true} SessionType={sessionType} /> : "-"}
                            </td>
                        </tr>
                    ) : null
            }
        </>
    );
};

export default ResultsCommentsTable;
